import { render, staticRenderFns } from "./global-message.vue?vue&type=template&id=9d7a9820&scoped=true&"
import script from "./global-message.vue?vue&type=script&lang=js&"
export * from "./global-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a9820",
  null
  
)

export default component.exports